import { Link, useParams, useSearchParams } from "react-router";
import { categories, PER_PAGE } from "../data/shows.js";
import Card from "../components/Card.jsx";
import Pagination from "../components/Pagination.jsx";
import NotFound from "./NotFound.jsx";
import AdBanner from "../components/AdsBanner.jsx";

export default function ShowPage() {
  const { slug } = useParams();
  const [params, setParams] = useSearchParams();
  const category = categories.find((c) => c.slug === slug);
  if (!category || category.comingSoon) return <NotFound />;

  const total = Math.max(1, Math.ceil(category.items.length / PER_PAGE));
  const page = Math.min(Math.max(Number(params.get("page")) || 1, 1), total);
  const items = category.items.slice((page - 1) * PER_PAGE, page * PER_PAGE);

  return (
    <section>
      <div className="mb-8 flex flex-wrap items-center gap-4">
        <Link to="/" className="rounded-lg border border-line px-4 py-2 text-sm font-semibold transition hover:border-glow focus-visible:outline-2 focus-visible:outline-glow">
          ‹ Back
        </Link>
        
       
        <h1 className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl">{category.title}</h1>
      </div>
      {/* ads native ban ads*/}
      <script async="async" data-cfasync="false" src="https://bellnewyork.org/21/e0480befad762d7e5f14a45960f9e186"></script>
      <div id="container-e0480befad762d7e5f14a45960f9e186"></div>
       

      <div className="grid gap-4 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4">
        {items.map((item) => <Card key={item.id} item={item} slug={category.slug} />)}
      </div>

      {/* ye ban call ki hai */}
      <AdBanner></AdBanner>

      <Pagination
        page={page}
        total={total}
        onChange={(n) => { setParams({ page: n }); window.scrollTo({ top: 0, behavior: "smooth" }); }}
      />
    </section>
  );
}
